import React from 'react';
import { ProjectModel } from '@bryntum/schedulerpro';
import { createWidget, shouldComponentUpdate, processWidgetContent } from './WrapperHelper.js';
export class BryntumProjectModel extends React.Component {
    constructor() {
        super(...arguments);
        this.processWidgetContent = processWidgetContent;
        this.dataStores = {
            'assignmentStore': 'assignments',
            'calendarManagerStore': 'calendars',
            'dependencyStore': 'dependencies',
            'eventStore': 'events',
            'resourceStore': 'resources',
            'resourceTimeRangeStore': 'resourceTimeRanges',
            'timeRangeStore': 'timeRanges'
        };
    }
    componentDidMount() {
        this.instance = createWidget(this);
    }
    componentWillUnmount() {
        var _a, _b;
        (_b = (_a = this.instance) === null || _a === void 0 ? void 0 : _a.destroy) === null || _b === void 0 ? void 0 : _b.call(_a);
    }
    shouldComponentUpdate(nextProps, nextState) {
        return shouldComponentUpdate(this, nextProps, nextState);
    }
    render() {
        return null;
    }
}
BryntumProjectModel.instanceClass = ProjectModel;
BryntumProjectModel.instanceName = 'ProjectModel';
BryntumProjectModel.configNames = [
    'adjustDurationToDST',
    'assignmentModelClass',
    'assignmentsData',
    'assignmentStoreClass',
    'autoLoad',
    'autoSync',
    'autoSyncTimeout',
    'bubbleEvents',
    'calendarManagerStoreClass',
    'calendarModelClass',
    'calendarsData',
    'callOnFunctions',
    'delayCalculation',
    'dependenciesData',
    'dependencyModelClass',
    'dependencyStoreClass',
    'encoder',
    'eventModelClass',
    'eventsData',
    'eventStoreClass',
    'listeners',
    'maxCalendarRange',
    'phantomIdField',
    'phantomParentIdField',
    'resetIdsBeforeSync',
    'resetUndoRedoQueuesAfterLoad',
    'resourceAllocationInfoClass',
    'resourceModelClass',
    'resourcesData',
    'resourceStoreClass',
    'resourceTimeRangesData',
    'resourceTimeRangeStoreClass',
    'silenceInitialCommit',
    'skipSuccessProperty',
    'storeIdProperty',
    'supportShortSyncResponse',
    'taskStore',
    'timeRangesData',
    'timeRangeStoreClass',
    'trackResponseType',
    'transport',
    'validateResponse',
    'writeAllFields'
];
BryntumProjectModel.propertyConfigNames = [
    'addConstraintOnDateSet',
    'assignments',
    'assignmentStore',
    'calendar',
    'calendarManagerStore',
    'calendars',
    'crudStores',
    'daysPerMonth',
    'daysPerWeek',
    'dependencies',
    'dependenciesCalendar',
    'dependencyStore',
    'enableProgressNotifications',
    'events',
    'eventStore',
    'forceSync',
    'hoursPerDay',
    'json',
    'loadUrl',
    'onBeforeDestroy',
    'onBeforeLoad',
    'onBeforeLoadApply',
    'onBeforeResponseApply',
    'onBeforeSend',
    'onBeforeSync',
    'onBeforeSyncApply',
    'onCatchAll',
    'onChange',
    'onCycle',
    'onDataReady',
    'onDestroy',
    'onEmptyCalendar',
    'onHasChanges',
    'onLoad',
    'onLoadCanceled',
    'onLoadFail',
    'onNoChanges',
    'onProgress',
    'onRequestDone',
    'onRequestFail',
    'onSchedulingConflict',
    'onSync',
    'onSyncCanceled',
    'onSyncDelayed',
    'onSyncFail',
    'resources',
    'resourceStore',
    'resourceTimeRanges',
    'resourceTimeRangeStore',
    'skipNonWorkingTimeInDurationWhenSchedulingManually',
    'skipNonWorkingTimeWhenSchedulingManually',
    'stm',
    'syncApplySequence',
    'syncUrl',
    'timeRanges',
    'timeRangeStore',
    'timeZone',
    'trackProjectModelChanges'
];
BryntumProjectModel.propertyNames = [
    'inlineData'
];
//# sourceMappingURL=BryntumProjectModel.js.map